import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const verizonConfig: TSPConfig = {
  key: 'verizon',
  name: 'Verizon Connect (Reveal)',
  imageName: 'Verizon Connect',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the credentials you use to log into the Verizon Reveal Web App.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Fleet Name (optional)',
          name: 'carriername',
          type: 'text',
          required: false,
        },
        {
          label: 'DOT Number (optional)',
          name: 'dotnumber',
          type: 'number',
          required: false,
        },
      ]}
    />
  ),
};

export default verizonConfig;
